import React from "react";
import Card from "react-bootstrap/Card";

import applestore from "../../assets/icons/applestore.svg";
import googleplay from "../../assets/icons/googleplay.svg";
import "./card.css";

function CardApplication(props) {
  return (
    <Card className="cardApplication w-100">
      <Card.Body className="panel">
        <Card.Title className="k-semibold-20">THE APPLICATION</Card.Title>
        <div className="text-center">
          <button
            className="btn"
            onClick={() => {
              // console.log(`AppleStore`);
            }}
          >
            <img src={applestore} alt="" />
          </button>
          <button
            className="btn"
            onClick={() => {
              // console.log(`AppleStore`);
            }}
          >
            <img src={googleplay} alt="" />
          </button>
        </div>
      </Card.Body>
    </Card>
  );
}

export default CardApplication;
